import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography, useTheme } from '@mui/material';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { StatCard } from '../../../../components/StatCard';
import { useStudyContext } from '../../../../context';
import { useEffect, useRef, useState } from 'react';
const baseOptions = {
    title: { text: undefined },
    chart: { type: 'column', height: 420 },
    xAxis: {
        categories: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        tickInterval: 1,
        gridLineWidth: 1,
        lineColor: '#F0F0F0',
        title: { text: 'Creative Rating', margin: 20, style: { fontWeight: '700', color: '#2D2D2D' } },
    },
    yAxis: {
        min: 0,
        max: 7,
        tickInterval: 1,
        gridLineWidth: 1,
        lineColor: '#F0F0F0',
        title: { text: 'Frequency', margin: 20, style: { fontWeight: '700', color: '#2D2D2D' } },
    },
    legend: { enabled: false },
    plotOptions: { column: { borderRadius: 4, groupPadding: 0 } },
    tooltip: {
        formatter() {
            return `<b>Rating ${this.key}</b><br/>Frequency: <b>${this.y}</b>`;
        },
    },
    credits: { enabled: false },
    series: [
        {
            type: 'column',
            name: 'Frequency',
            color: '#A6CEE3',
            data: Array(10).fill(0),
        },
    ],
};
export const CreativeRatingChart = () => {
    const theme = useTheme();
    const { studyResultData } = useStudyContext();
    const [averageRating, setAverageRating] = useState(0);
    const chartRef = useRef(null); // ⬅️ get access to the real chart
    useEffect(() => {
        var _a;
        if (!(studyResultData === null || studyResultData === void 0 ? void 0 : studyResultData.result))
            return;
        const ratings = studyResultData.result.panelMembers.map(m => m.creativeRating);
        const freq = Array(10).fill(0);
        ratings.forEach(r => {
            if (r >= 1 && r <= 10)
                freq[r - 1] += 1;
        });
        (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.chart.series[0].setData(freq, true);
        const avg = ratings.reduce((sum, r) => sum + r, 0) / ratings.length;
        setAverageRating(Number.isFinite(avg) ? +avg.toFixed(2) : 0);
    }, [studyResultData]);
    return (_jsxs(Stack, { flex: 1, gap: "10px", border: 1, minWidth: "543px", padding: "16px", borderRadius: "4px", borderColor: theme.palette.grey[300], children: [_jsx(StatCard, { title: "Panel Creative Rating", icon: ThumbUpAltOutlinedIcon, children: _jsx(Stack, { gap: "3px", children: _jsx(Typography, { fontWeight: 600, fontSize: "24px", color: theme.palette.text.primary, children: averageRating }) }) }), _jsx(HighchartsReact, { highcharts: Highcharts, options: baseOptions, ref: chartRef })] }));
};
